export default __webpack_public_path__ + "static/media/infoRed.2e7c5860.svg";